/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Dashboard - use SWR
 */
import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  CONNECTION_STATUS_FETCH: null,
  CONNECTION_STATUS_FETCH_SUCCESS: null,
  CONNECTION_STATUS_FETCH_FAILED: null,

  REDIRECT_SUBMIT: null,
  REDIRECT_SUBMIT_SUCCESS: null,
  REDIRECT_SUBMIT_FAILED: null,

  CHART_OF_ACCOUNT_FETCH: null,
  CHART_OF_ACCOUNT_FETCH_SUCCESS: null,
  CHART_OF_ACCOUNT_FETCH_FAILED: null,

  TAX_MAPPING_FETCH: null,
  TAX_MAPPING_FETCH_SUCCESS: null,
  TAX_MAPPING_FETCH_FAILED: null,

  PRODUCT_MAPPING_FETCH: null,
  PRODUCT_MAPPING_FETCH_SUCCESS: null,
  PRODUCT_MAPPING_FETCH_FAILED: null,

  PRODUCT_MAPPING_SUBMIT: null,
  PRODUCT_MAPPING_SUBMIT_SUCCESS: null,
  PRODUCT_MAPPING_SUBMIT_FAILED: null,

  TAX_MAPPING_SUBMIT: null,
  TAX_MAPPING_SUBMIT_SUCCESS: null,
  TAX_MAPPING_SUBMIT_FAILED: null,

  PRODUCT_MAPPING_DELETE: null,
  PRODUCT_MAPPING_DELETE_SUCCESS: null,
  PRODUCT_MAPPING_DELETE_FAILED: null,
});

export type ConfigurationState = {
  showConfigurationModal: boolean;
};

export type MappingProductAndAdmin = {
  API_DISBURSEMENT: string;
  BULK_DISBURSEMENT: string;
  CLAIM_FUND: string;
  VA_AGGREGATOR: string;
  EWALLET_AGGREGATOR: string;
  PAYMENT_CHECKOUT: string;
  ADMIN_FEE: string;
  TAX: string;
};
